import React from 'react';
import CrudTable from '../../components/common/CrudTable';
import { faqAPI } from '../../api/services';

const COLUMNS = [
  { key: 'question', label: 'Question' },
  { key: 'answer', label: 'Answer', render: (item) => item.answer?.length > 60 ? item.answer.substring(0, 60) + '...' : item.answer },
];

const FORM_FIELDS = [
  { name: 'question', label: 'Question', placeholder: 'How do I register?' },
  { name: 'answer', label: 'Answer', type: 'textarea', placeholder: 'Enter the answer...' },
];

const FAQsAdmin = () => (
  <CrudTable
    title="FAQs"
    entityName="FAQ"
    columns={COLUMNS}
    formFields={FORM_FIELDS}
    fetchData={async () => {
      const res = await faqAPI.getAll();
      return res.data?.data || [];
    }}
    onAdd={(data) => faqAPI.add(data)}
    onUpdate={(id, data) => faqAPI.update(id, data)}
    onDelete={(id) => faqAPI.delete(id)}
  />
);

export default FAQsAdmin;
